<mat-dialog-content style="padding: 40px;">
    <div class="d-flex position-relative">
        <img class="mx-auto" style="height: 40px;" src="assets/icons/logo-black-notext.png" />
        <img (click)="CloseModal()" class="my-auto position-absolute" style="height: 24px; right: 5px; cursor: pointer;"
            src="assets/icons/x-close.png" />
    </div>
    <h1 class="premium-title text-center mb-1 mt-4">
        Upgrade to VidTao Premium to get unlimited access to the YouTube Ad Database,
        PLUS...
    </h1>
    <ul class="mt-5">
        <li class="list-item">Exclusive access to new features</li>
        <li class="list-item">10% Savings on all VidTao Live events</li>
        <li class="list-item"><span style="text-decoration:underline">Free Access to our internal training
                library</span> we use to train all our media buyers &
            creatives on YouTube,
            TikTok, FB/IG, Native and more (from our Inceptly Agency team with $150M in managed adspend)</li>
    </ul>
    <div class="prices d-block text-center mt-4">
        <!-- <p style="text-decoration:line-through" class="mb-0">Regular Price: $67/month
        </p>
        <p class="mb-0">Q2 2023 Special Price: <b>$49/month</b></p>
        <p style="color: red;" class="mb-0"><b>(save 26% - ends July 1, 2023)</b></p> -->
        <p style="font-weight: 550; text-align: end; font-size: 18px;" class="mb-0 ml-auto">
            {{subscriptionPlan.name}}
        </p>
        <p style="font-weight: 550; text-align: end; font-size: 18px;" class="mb-0 ml-auto">Price:
            ${{subscriptionPlan.price}}
        </p>
    </div>
    <p class="list-item please-enter mt-3">
        Please enter your details
    </p>
    <P class="list-item">
        We collect this information to help combat fraud, and to keep your payment secure.
    </P>
    <div class='checkout-container'></div>
</mat-dialog-content>